export class UserModel {
  userId: number;
  companyId: number;
  fullName: string;
  username: string;
  countryCallingCode: string;
  telephone: string;
  companyTitleTh: string;
  companyTitleEn: string;

  companyCode?: string;
  features?: FeatureModel[];
  Langid: number;
  email: string;
  birthdate: string;
  profileImage: string;
  addresses: AddressModel[];
  position: string;
  timeOfBirth: string;
  userSetting: UserSetting;
}

export class AddressModel {
  taxAddressId: number;
  title: string;
  taxNumber: string;
  address: string;
  isDefault: boolean;
  active: boolean;
}

export class FeatureModel {
  feature: string;
  allow?: boolean;
  data?: any;

  constructor(feature?: string, allow?: boolean, data?: any) {
    this.feature = feature;
    this.allow = allow;
    this.data = data;
  }
}

export class BudgetLimitModel {
  isLimitBudget: boolean;
  budget: number;
  description: string;

  constructor(isLimitBudget?: boolean, budget?: number, description?: string) {
    this.isLimitBudget = isLimitBudget;
    this.budget = budget;
    this.description = description;
  }
}

export class FeatureNotifyModel extends FeatureModel {
  disabled?: boolean;
  data: {
    display: boolean;
    hasCheckbox: boolean;
    popupMessageTH: string;
    popupMessageEN: string;
  };
}

export class FeatureBookForTraveller {
  useTravellerBudget: boolean;
  useTravellerApproval: boolean;
  useTravellerReporter: boolean;
  additionalTravellerFields: AdditionalTravellerFieldsModel[]
}

export class AdditionalTravellerFieldsModel {
  fieldId: string;
  displayNameEn: string;
  displayNameTh: string;
  descriptionEn: string;
  descriptionTh: string;
  require: boolean;
  disable: boolean;
  allowSavingData: boolean;
}

export class UserSetting {
  lang: string;
  currency: string;
}



// WEBPACK FOOTER //
// ./src/app/model/user.model.ts